import React from 'react';
import { useHistory } from 'react-router-dom';
import { differenceInDays } from 'date-fns';
import { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import { Card, CardActionArea } from '@material-ui/core';
import { Person as PersonIcon } from '@material-ui/icons';
import BoardItem from './BoardItem';

export interface BoardItemProps {
  task: any;
  provided: DraggableProvided;
  snapshot: DraggableStateSnapshot;
  isLoading?: boolean;
}

const BoardItemWithSubtask: React.FC<BoardItemProps> = (
  props: BoardItemProps
) => {
  const { task, provided, isLoading } = props;
  const history = useHistory();
  return (
    <Card
      className='task-card-with-subtask'
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
      onClick={() => {
        history.push(`/portal/admin/training/${task.id}`);
      }}
    >
      <div className='title'>{task.name}</div>
      {task.children.map((subTask: any) => (
        <BoardItem key={subTask.id} {...{ task: subTask }} />
      ))}
    </Card>
  );
};

export default BoardItemWithSubtask;
